import { DataProvider, useAsyncData } from '@repo/ui/dataProvider'

import { Assistant } from '@/components/assistant/Assistant'
import { AssistantAlertsOnly } from '@/components/assistant/AssistantAlertsOnly'
import { AssistantErrorMessage } from '@/components/assistant/messages/ErrorMessage'
import { RootState } from '@/store'
import { useFeatureFlags } from '@/store/feature-flags/hooks'
import { getCurrentBeneficiary, getCurrentOrganization } from '@/store/helpers'

export function AssistantWrapper() {
  const { hasFeature } = useFeatureFlags()
  const hasChatFeature = hasFeature('chat')
  return (
    <DataProvider
      selectors={[getCurrentOrganization]}
      render={(_) => <Wrap status={hasChatFeature ? 'alertsOnly' : 'default'} />}
    />
  )
}

function Wrap({ status }: { status: 'alertsOnly' | 'default' }) {
  const {
    data: [beneficiary],
  } = useAsyncData([getCurrentBeneficiary])
  if (status === 'default') return <Assistant beneficiary={beneficiary} />
  else if (status === 'alertsOnly')
    return (
      <DataProvider
        selectors={[(state: RootState) => state.alert.all]}
        errorComponent={<AssistantErrorMessage />}
        render={(alerts) => {
          if (alerts.length === 0) return null
          return <AssistantAlertsOnly alerts={alerts} />
        }}
      />
    )
}
